const STONES = {
  1: { stone: "amber", fill: "#f59e0b", mid: "#fbbf24", edge: "#b45309" },
  2: { stone: "ruby", fill: "#e11d48", mid: "#fb7185", edge: "#9f1239" },
  3: { stone: "emerald", fill: "#10b981", mid: "#34d399", edge: "#047857" },
};

/** Faceted Infinity-stone jewel for podium ranks 1–3. */
export const RankGem = ({ rank, className = "" }) => {
  const g = STONES[rank];
  if (!g) return null;
  const id = `gem-${g.stone}`;
  return (
    <svg
      data-testid={`podium-gem-${rank}`}
      data-gem={g.stone}
      className={`rank-gem rank-gem-${g.stone} ${className}`}
      width="28"
      height="28"
      viewBox="0 0 32 32"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={`${id}-body`} x1="20%" y1="0%" x2="80%" y2="100%">
          <stop offset="0%" stopColor={g.mid} />
          <stop offset="45%" stopColor={g.fill} />
          <stop offset="100%" stopColor={g.edge} />
        </linearGradient>
        <radialGradient id={`${id}-shine`} cx="32%" cy="28%" r="55%">
          <stop offset="0%" stopColor="#fff" stopOpacity="0.85" />
          <stop offset="40%" stopColor="#fff" stopOpacity="0.15" />
          <stop offset="100%" stopColor="#fff" stopOpacity="0" />
        </radialGradient>
      </defs>
      <polygon
        points="16,2 28,12 16,30 4,12"
        fill={`url(#${id}-body)`}
        stroke={g.edge}
        strokeWidth="1"
      />
      <polygon points="16,2 22,12 16,14 10,12" fill="#fff" opacity="0.28" />
      <polygon points="16,14 28,12 16,30" fill="#000" opacity="0.18" />
      <ellipse cx="13" cy="11" rx="4.5" ry="3" fill={`url(#${id}-shine)`} />
    </svg>
  );
};

